// ANGULAR
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
// SERVICES
import { AlertService } from '@services/alert.service';
import { GlobalService } from '@services/global.service';
import { EdicionService } from '@api-requests-services/edicion.service';
import { BackupsService } from '@api-requests-services/backups.service';
// RXJS
import { finalize } from 'rxjs';

export enum Views {
  Home = 'home',
  ModifyFrequency = 'modifyFrequency',
  Comparison = 'Comparison',
}

@Component({
  selector: 'app-edicion',
  templateUrl: './edicion.component.html',
  styleUrl: './edicion.component.css',
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class EdicionComponent implements OnInit {
  views = Views;
  currentView: string = Views.Home;
  secondsFrequency: number;
  backupComparison: string = '';
  backupComparisonInProgress: boolean = false;

  constructor(
    private alertService: AlertService,
    public globalService: GlobalService,
    private backupsService: BackupsService,
    private edicionService: EdicionService,
    private title: Title
  ) {
    this.title.setTitle('Oráculo - Edición');
  }

  ngOnInit(): void { }

  getBackground(value: boolean): string {
    if (value === true) {
      return 'background-color: var(--true-color);';
    } else {
      return 'background-color: var(--false-color);';
    }
  }

  selectView(view: string): void {
    this.currentView = view;

    switch(view) {
      case Views.Home:
        break;
      case Views.ModifyFrequency:
        this.getSecondsIntervalUpdates(false);
        break;
      case Views.Comparison:
        this.compareModes();
        break;
    }
  }

  getModoEdicion(): void {
    this.edicionService.getModoEdicion().subscribe(
      editMode => {
        if (editMode) {
          // console.log('Modo edición: ', editMode); 

          if (!this.globalService.pressStartEditingButton && editMode.modoEdicion) {
            this.globalService.setEditing(true);
            this.globalService.setPressStartEditingButton(true);

            this.alertService.showBasicMessage(
              `¡Atención! El Modo Edición ya está iniciado`, 
              `Comentario: ${editMode.comentario ?? ''}`, 
              "warning", 
              true
            );
          } else if (this.globalService.pressStartEditingButton && editMode.modoEdicion) {
            this.globalService.setEditing(true);

            this.alertService.showMessageWithImage(
              'Si está en modo edición',
              `Comentario: ${editMode.comentario ?? ''}`,
              'assets/images/si.jpg'
            );
          } else {
            this.globalService.setEditing(false);
            this.globalService.setPressStartEditingButton(false);

            this.alertService.showMessageWithImage('No está en modo edición', '', 'assets/images/no.jpg');
          }
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting Edit Mode:', error);
        }
      }
    );
  }

  getEditado(): void {
    this.edicionService.getEditado().subscribe(
      edited => {
        if (edited !== undefined) {
          // console.log('Editado: ', edited);  
          let title: string = '';
          let imageUrl: string = '';

          if (edited) {
            imageUrl = 'assets/images/si.jpg';
            title = 'Si está editado';
          } else {
            imageUrl = 'assets/images/no.jpg';
            title = 'No está editado';
          }

          this.alertService.showMessageWithImage(title, '', imageUrl);
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting Edited:', error);
        }
      }
    );
  }

  getSecondsIntervalUpdates(showSwal: boolean): void {
    this.edicionService.getSegundosIntervaloActualizaciones().subscribe(
      secondsIntervalUpdates => {
        if (secondsIntervalUpdates) {
          this.secondsFrequency = secondsIntervalUpdates;

          if (showSwal) {
            this.alertService.showBasicMessage(`${secondsIntervalUpdates} segundos`, ``, "success", false);
          }
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          if (showSwal) {
            this.alertService.swalEditingNotEnabled();
          }
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting Seconds Interval Updates:', error);
        }
      }
    );
  }

  updateSecondsIntervalUpdates(): void {
    this.edicionService.putEditSegundosIntervaloActualizaciones(this.secondsFrequency).subscribe(
      () => {
        this.selectView(Views.Home);
        this.alertService.showAutoCloseMessage(`Intervalo de actualizaciones actualizado`, ``, "success", 1200);
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error modifying Seconds Interval Updates:', error);
        }
      }
    );
  }

  compareModes(): void {
    this.backupComparison = '';
    this.backupComparisonInProgress = true;

    this.backupsService.getBackupsComparar(null, '')
      .pipe(finalize(() => this.backupComparisonInProgress = false))
      .subscribe(
        backupComparison => {
          if (backupComparison) {
            // console.log('Comparación de backups: ', backupComparison);
            const backupComparisonFormatted: string = `<pre>${JSON.stringify(backupComparison, null, 2)}</pre>`;
            this.backupComparison = backupComparisonFormatted;
          }
        },
        error => {
          this.alertService.swalError(error.error);
          console.error('Error getting Backups Comparison:', error);
        }
      );
  } 
}